import { ITipoRelacaoCliente } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoRelacaoCliente/TipoRelacaoClienteInterface";
import {
    AlterarTipoRelacaoClienteService,
    ExcluirTipoRelacaoClienteService,
    InserirTipoRelacaoClienteService,
    ListarTipoRelacaoClienteService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteServices";
import { Controller } from "../../../Controller";

export async function ListarTipoRelacaoClienteController() {
    return Controller(ListarTipoRelacaoClienteService());
}

export async function AlterarTipoRelacaoClienteController(
    requestBody: ITipoRelacaoCliente
) {
    return Controller(AlterarTipoRelacaoClienteService(requestBody));
}

export async function InserirTipoRelacaoClienteController(
    requestBody: Omit<ITipoRelacaoCliente, "TIPO_RELACAO_CLIENTE">
) {
    return Controller(InserirTipoRelacaoClienteService(requestBody));
}

export async function ExcluirTipoRelacaoClienteController(
    idTipoRealcao: number
) {
    return Controller(ExcluirTipoRelacaoClienteService(idTipoRealcao));
}
